var React = require('react');

function Bars (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 3"),React.createElement("g",{"id":"Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Home-Header","transform":"translate(-325.000000, -20.000000)","fill":"currentColor"},React.createElement("g",{"id":"Group-3","transform":"translate(325.000000, 20.000000)"},[React.createElement("rect",{"id":"Rectangle","x":"0","y":"0","width":"30","height":"2","rx":"1","key":0}),React.createElement("rect",{"id":"Rectangle-Copy-2","x":"0","y":"9","width":"30","height":"2","rx":"1","key":1}),React.createElement("rect",{"id":"Rectangle-Copy-3","x":"0","y":"18","width":"30","height":"2","rx":"1","key":2})])))]);
}

Bars.defaultProps = {"width":"30px","height":"20px","viewBox":"0 0 30 20","version":"1.1"};

module.exports = Bars;

Bars.default = Bars;
